"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var UserInfo_1 = require("../../user/model/UserInfo");

var UserInfoConverter_1 = require("./UserInfoConverter");
/**
 * Default implementation of user info converter.
 *
 * @author Radek Beran
 */


var UserInfoConverterImpl =
/*#__PURE__*/
function (_UserInfoConverter_1$) {
  _inherits(UserInfoConverterImpl, _UserInfoConverter_1$);

  function UserInfoConverterImpl() {
    _classCallCheck(this, UserInfoConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(UserInfoConverterImpl).apply(this, arguments));
  }

  _createClass(UserInfoConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new UserInfo_1.UserInfo(source.id, source.name);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        id: source.id
      });
      Object.assign(result, {
        name: source.name
      });
      return result;
    }
  }]);

  return UserInfoConverterImpl;
}(UserInfoConverter_1.UserInfoConverter);

exports.UserInfoConverterImpl = UserInfoConverterImpl;